import request from '../requestPB'
import { SERVER_DOMAIN, PROTO_MODULE } from '../constant'

export const cardClassifyDetail = (params) => {
    return request({
      url: `${SERVER_DOMAIN}/api/v1/card_classify/detail`,
      data: params,
      method: 'POST',
    }, {
      PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSCardClassifyDetailRequest',
      PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSCardClassifyDetailResponse',
      ERROR_ACTION: 'toast',
      PROTO_MODULE: PROTO_MODULE.PRODUCT,
      TOKEN_REQUIRED: true
    })
  }


export const myCardClassifyDetail = (params) => {
    return request({
      url: `${SERVER_DOMAIN}/api/v1/card_classify/record_detail`,
      data: params,
      method: 'POST',
    }, {
      PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSMyCardClassifyDetailRequest',
      PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSMyCardClassifyDetailResponse',
      ERROR_ACTION: 'toast',
      PROTO_MODULE: PROTO_MODULE.PRODUCT,
      TOKEN_REQUIRED: true
    })
  }

export const expertCardReport = (params) => {
    return request({
      url: `${SERVER_DOMAIN}/api/v1/card_expert_appraisal/report`,
      data: params,
      method: 'POST',
    }, {
      PB_LOOK_TYPE_PATH_REQUEST: 'proto.CardExpertAppraisalReportRequest',
      PB_LOOK_TYPE_PATH_RESPONSE: 'proto.CardExpertAppraisalReportResponse',
      ERROR_ACTION: 'toast',
      PROTO_MODULE: PROTO_MODULE.PRODUCT,
      TOKEN_REQUIRED: true
    })
  }
export const expertCardReports = (params) => {
    return request({
      url: `${SERVER_DOMAIN}/api/v1/card_expert_appraisal/reports`,
      data: params,
      method: 'POST',
    }, {
      PB_LOOK_TYPE_PATH_REQUEST: 'proto.CardExpertAppraisalReportsRequest',
      PB_LOOK_TYPE_PATH_RESPONSE: 'proto.CardExpertAppraisalReportsResponse',
      ERROR_ACTION: 'toast',
      PROTO_MODULE: PROTO_MODULE.PRODUCT,
      TOKEN_REQUIRED: true
    })
  }